import React, { useMemo, useState } from 'react'
import './index.less'
import { Input, Avatar, Pagination } from 'antd'
import { NComment, EGetComment, EPostCommentReply } from '../../../models/constants'
import { effect, useStore } from '../../../dva16'

function reply(reply = []) {
  return (
    <div className="reply">
      {reply.map((item, index) => (
        <div key={index} style={{ display: item.isShow ? 'block' : 'none' }}>
          <div className="reply-header">
            <Avatar size={30} src={(item.user && item.user.icon) || require('../../static/avatar.svg')} />
            <span>{item.user && item.user.nickname}</span>
            <span>{item.createdAt}</span>
          </div>
          <div className="reply-center">{item.content}</div>
          {/* <div className="reply-foot">
            <img src={require('../../static/reply-2.svg')} alt="" />
            <span>回复</span>
          </div> */}
        </div>
      ))}
      {/* <div className="relpy-more">
        <span>更多评论</span>
        <span>></span>
      </div> */}
    </div>
  )
}

function CommentList(id) {
  let [isShowReply, setIsShowReply] = useState(true)
  let [commentID, setCommentID] = useState()
  let [content, setContent] = useState()
  let { comment } = useStore(NComment)
  // console.log(comment, 'comment')

  const handleClickReplayButton = (replyid, content) => {
    effect(NComment, EPostCommentReply, { id: Number(replyid), content, infoID: id })
    setContent()
  }

  const handleClickPage = page => {
    effect(NComment, EGetComment, { id, page })
  }
  const replyButton = (
    <div className="button" onClick={() => handleClickReplayButton(commentID, content)}>
      回复
    </div>
  )
  useMemo(() => {
    effect(NComment, EGetComment, { id })
  }, [])

  return (
    <div id="comment">
      <p>全部评论({comment.total})</p>
      {comment.data.map((item, index) => (
        <div id="list-card" key={index} style={{ display: item.isShow ? 'block' : 'none' }}>
          <div className="item-container">
            <div className="item-header">
              <div className="item-header-left">
                <Avatar size={56} src={(item.user && item.user.icon) || require('../../static/avatar.svg')} />
              </div>
              <div className="item-header-right">
                <div className="item-title">
                  <span>{item.user && item.user.nickname}</span>
                  <span>|</span>
                  <span>萌新</span>
                </div>
                <div className="sofa">
                  <div>发布于：{item.createdAt}</div>
                  <div>{index === 0 ? '#沙发' : `#${(comment.page - 1) * 10 + (index + 1)}F`}</div>
                </div>
              </div>
            </div>
            <div className="item-center">{item.content}</div>
            {isShowReply && item.id === commentID && (
              <div className="input">
                <Input value={content} onChange={e => setContent(e.target.value)} size="large" addonAfter={replyButton} />
              </div>
            )}
            <div className="item-foot">
              <img src={require('../../static/reply-2.svg')} alt="" />
              <span
                onClick={() => {
                  if (item.id === commentID || !isShowReply) {
                    setIsShowReply(!isShowReply)
                  }

                  setCommentID(item.id)
                }}
              >
                回复
              </span>
            </div>
            {item.replyList.length !== 0 && reply(item.replyList)}
          </div>
        </div>
      ))}
      {comment.total !== 0 && (
        <div className="pagesize">
          <Pagination
            onChange={page => handleClickPage(page)}
            current={comment.page}
            pageSize={comment.perPage || 10}
            total={comment.total}
          />
        </div>
      )}
    </div>
  )
}

export default CommentList
